export function useMetaHelper() {
  const { $tr } = useNuxtApp()

  function getTitle (parts = null) {
    const titleSuffixVeryShort = 'SunGod'
    const titleSuffixShort = 'SunGod. See Better.'
    const titleSuffixLong = 'SunGod. See Better.'
  
    if (!parts) return titleSuffixLong
  
    if (typeof parts === 'string') parts = [parts]
    parts = parts.filter(part => part)
    const title = parts.join(' | ')
    if (title.length > 40) return `${(title)} | ${titleSuffixVeryShort}`
    return `${(title)} | ${titleSuffixShort}`
  }

  function getDescription (description, ...args) {
    return [{
      hid: 'description',
      name: 'description',
      content: $tr(description, ...args)
    }, {
      hid: 'og:description',
      property: 'og:description',
      content: $tr(description, ...args)
    }]
  }

  return { getTitle, getDescription }
}
